module.exports = __webpack_public_path__ + "static/media/default_thumbnail_427_240.d1a13025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_427_240.jpg
// module id = 311
// module chunks = 2